import React from 'react'
import {
    VStack,
    HStack,
    Text,
    Link,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {EmailIcon, ReturnIcon} from '../../../components/icons'
import {useIntl} from 'react-intl'
import useUtils from '../../../custom-hooks/use-utils-helper'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import routingObject from '../../../utils/static-routes'
import {useCustomPreference} from '../../../hooks/use-custom-preference'

const CartPolicies = () => {
    const style = useMultiStyleConfig('Cart', {})
    const {formatMessage} = useIntl()
    const {policies} = style
    const {isCart} = useUtils().currentPage(location.pathname)
    const {buildUrl} = useMultiSite()
    const isGiftNoteVisible = useCustomPreference('showNoteFlag')

    return (
        <VStack {...policies?.policiesContainer}>
            {isCart && isGiftNoteVisible?.showNoteFlag === 'true' && (
                <VStack {...policies?.section}>
                    <HStack {...policies?.header}>
                        <EmailIcon {...policies?.icon} aria-hidden="true" />
                        <Text {...policies?.title}>
                            {formatMessage({
                                id: 'cart_default.cart_policies.gift_title',
                                defaultMessage: 'Gift Note',
                            })}
                        </Text>
                    </HStack>
                    <Text {...policies?.message}>
                        {formatMessage({
                            id: 'cart_default.cart_policies.gift_message',
                            defaultMessage:
                                'If it’s a gift, you can write a personalized greeting card at the checkout',
                        })}
                    </Text>
                </VStack>
            )}
            <VStack {...policies?.section}>
                <HStack {...policies?.header}>
                    <ReturnIcon {...policies?.icon} aria-hidden="true" />
                    <Text {...policies?.title}>
                        {formatMessage({
                            id: 'cart_default.cart_policies.return_title',
                            defaultMessage: 'Return',
                        })}
                    </Text>
                </HStack>
                <Text {...policies?.message}>
                    {formatMessage(
                        {
                            id: 'cart_default.cart_policies.return_message',
                            defaultMessage:
                                'You can return items purchased on our official website within 30 days of their shipment for a full refund of the purchase price. {link}',
                        },
                        {
                            link: (
                                <Link
                                    {...policies?.link}
                                    href={buildUrl(routingObject.FAQ_PATH)}
                                    aria-label={formatMessage({
                                        id: 'cart_default.cart_policies.faq_link',
                                        defaultMessage: 'Read more about our return policy in FAQ',
                                    })}
                                >
                                    FAQ
                                </Link>
                            ),
                        },
                    )}
                </Text>
            </VStack>
        </VStack>
    )
}

export default CartPolicies
